// Incoming call during active call notification component
export const IncomingCallDuringCallNotification = ({
  callerName,
  callerImage,
  queueCount,
  onDecline,
}) => {
  return (
    <div className="fixed top-4 right-4 z-[10000] transform transition-all duration-300 ease-out opacity-100 translate-x-0">
      <div className="bg-white rounded-xl shadow-lg overflow-hidden w-80 border border-blue-400/20">
        {/* Top accent bar */}
        <div className="h-1 bg-gradient-to-r from-blue-500 to-blue-600"></div>

        <div className="p-4">
          {/* During call indicator */}
          <div className="mb-2 flex items-center text-xs text-blue-600 bg-blue-50 px-2 py-1 rounded">
            <div className="w-2 h-2 bg-blue-500 rounded-full mr-2 animate-pulse"></div>
            Incoming call during active call
          </div>

          <div className="flex items-center">
            {/* Caller image */}
            <div className="relative">
              {callerImage ? (
                <img
                  src={callerImage}
                  alt={callerName}
                  className="w-14 h-14 rounded-full object-cover border-2 border-blue-500 p-0.5 bg-white"
                />
              ) : (
                <div className="w-14 h-14 rounded-full bg-gray-100 border-2 border-blue-500 flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-7 w-7 text-gray-400"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              )}

              {/* Status indicator */}
              <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-blue-500 rounded-full border-2 border-white animate-pulse"></div>
            </div>

            {/* Caller info */}
            <div className="ml-3 flex-1">
              <h3 className="font-semibold text-gray-800">
                {callerName || "Unknown Caller"}
              </h3>
              <div className="flex items-center">
                <span className="inline-block w-2 h-2 bg-blue-500 rounded-full mr-2 animate-pulse"></span>
                <p className="text-sm text-gray-600">Wants to call you</p>
              </div>
              {queueCount > 1 && (
                <div className="flex items-center mt-1">
                  <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                    +{queueCount - 1} more waiting
                  </span>
                </div>
              )}
            </div>

            {/* Animated phone icon */}
            <div className="relative w-8 h-8 flex items-center justify-center">
              <div className="w-full h-full rounded-full bg-blue-500/20 absolute animate-ping"></div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-blue-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
            </div>
          </div>

          {/* Call actions */}
          <div className="mt-4 flex justify-between gap-2">
            <button
              onClick={onDecline}
              className="flex-1 py-2.5 px-3 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg flex items-center justify-center transition-all duration-300 hover:shadow text-sm"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 mr-1.5 rotate-135 text-red-500"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              Hide
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
